/* Assets -> custom.js */

document.addEventListener("DOMContentLoaded", function () {
  /* Announcement Bar*/
  var announcementBars = document.querySelectorAll(".utility-bar");
  var closeButtons = document.querySelectorAll(".announcement-cross-icon");

  if (localStorage.getItem("announcementClosed") === "true") {
    announcementBars.forEach(function (announcementBar) {
      announcementBar.style.display = "none";
    });
  }

  closeButtons.forEach(function (closeButton) {
    closeButton.addEventListener("click", function () {
      var announcementBar = this.closest(".utility-bar");
      announcementBar.style.display = "none";
      localStorage.setItem("announcementClosed", "true");
    });
  });

  /* Menu Drawer Toggle Caret Down Icon */
  document
    .querySelector("#HeaderDrawer-products")
    .addEventListener("click", function () {
      var caretIcons = document.querySelectorAll(".fa-caret-down");
      caretIcons.forEach(function (caretIcon) {
        caretIcon.style.transform =
          caretIcon.style.transform === "rotate(180deg)"
            ? "rotate(0deg)"
            : "rotate(180deg)";
      });
    });
});

/* Back To Top Button */
function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
}

/* FAQ Page */
$(document).ready(function () {
  $(".faq-question").click(function () {
    $(this).parent().find(".faq-answer").slideToggle();
    $(this).find(".angle-icon i").toggleClass("rotate");
    $(".faq-question").not(this).parent().find(".faq-answer").slideUp();
    $(".faq-question").not(this).find(".angle-icon i").removeClass("rotate");
  });
});

/* Events & Achievers Page */
document.addEventListener("DOMContentLoaded", () => {
  const pageBody = document.querySelector("body");
  const pageOverlay = document.querySelector(".slider-overlay");
  const slidersImage = document.querySelectorAll(".slider-inner-item");
  const slidersPopup = document.querySelectorAll(".slider-popup");
  const popupCross = document.querySelectorAll(".popup-cross");
  let slideIndex = 1;

  const hidePopup = () => {
    slidersPopup.forEach((popup) => (popup.style.display = "none"));
  };
  const showPopup = (index) => {
    hidePopup();
    slidersPopup[index].style.display = "block";
  };

  slidersImage.forEach((slider, index) => {
    slider.addEventListener("click", () => {
      slideIndex = 1;
      showSlides(slideIndex, index);
      if (
        slidersPopup[index].querySelectorAll(".slider-inner-popup").length > 0
      ) {
        showPopup(index);
        pageOverlay.classList.add("is-visible");
        pageBody.classList.add("overflow");
      } else {
        console.log("No Slider Value");
      }
    });
  });

  popupCross.forEach((crossIcon, index) => {
    crossIcon.addEventListener("click", () => {
      slidersPopup[index].style.display = "none";
      pageOverlay.classList.remove("is-visible");
      pageBody.classList.remove("overflow");
    });
  });

  const showSlides = (n, popupIndex) => {
    const popup = slidersPopup[popupIndex];
    if (!popup) {
      return;
    }

    const slides = popup.querySelectorAll(".slider-inner-popup");
    slideIndex = n > slides.length ? 1 : n < 1 ? slides.length : n;
    slides.forEach((slide, index) => {
      slide.style.display = "none";
      const slideNumberElement = slide.querySelector(".popup-image-count");
      slideNumberElement.textContent = `${index + 1} of ${slides.length}`;
    });

    if (slides[slideIndex - 1]) {
      slides[slideIndex - 1].style.display = "block";
    }
  };

  const plusSlide = (n) => {
    const currentPopupIndex = Array.from(slidersPopup).findIndex(
      (popup) => getComputedStyle(popup).display !== "none"
    );
    if (currentPopupIndex !== -1) {
      showSlides((slideIndex += n), currentPopupIndex);
    }
  };

  showSlides(slideIndex, 0);
  document.addEventListener("keydown", (e) => {
    if (e.keyCode === 37) plusSlide(-1); // Left Arrow key
    if (e.keyCode === 39) plusSlide(1); // Right Arrow key
  });

  document
    .querySelectorAll(".slider-popup .prev")
    .forEach((prev) => prev.addEventListener("click", () => plusSlide(-1)));
  document
    .querySelectorAll(".slider-popup .next")
    .forEach((next) => next.addEventListener("click", () => plusSlide(1)));
});

$(document).ready(function () {
  $(".Club_point").click(function () {
    const slider = $(".slider-items");

    // Check if Slick is already initialized
    if (slider.hasClass("slick-initialized")) {
      // Destroy the existing Slick instance
      slider.slick("unslick");
      initializeSlickSlider(".slider-items");
    }
  });
  initializeSlickSlider(".slider-items");
  function initializeSlickSlider(selector) {
    $(selector).slick({
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    });
  }

  if ($(window).width() > 750) {
    $(".product-media-cstm").slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: false,
      arrows: false,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
      asNavFor: ".product-thumbnail-cstm",
    });

    $(".product-thumbnail-cstm").slick({
      infinite: false,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      prevArrow:
        '<button type="button" class="slick-prev"><i class="fas fa-angle-left"></i></button>',
      nextArrow:
        '<button type="button" class="slick-next"><i class="fas fa-angle-right"></i></button>',
      asNavFor: ".product-media-cstm",
      focusOnSelect: true,
    });
  }
});

// Delivery message on product page
$(document).ready(function () {
  async function getTAT(destinationPin) {

    const reqData = {
      origin_pin: destinationPin,
      destination_pin: "110001",
    };

    const encrypted = CryptoUtil.encryptRequest("POST", reqData);

    const url = `${window.Base_Url.Base_Url}/delhivery/V3/TAT_APIV3`;

    const headers = {
      "Content-Type": "application/json",
      "seal": encrypted.seal,
    };
    const body = JSON.stringify({
      iv: encrypted.iv,
      payload: encrypted.payload,
    });
 
    try {
     
      const response = await fetch(url, {
        method: "POST",
        headers: headers,
        body: body,
      });
   //console.log("responseresponseaa" , response.ok)
      if (!response.ok) {
         let tgtDeliverymessagee = document.getElementById("delivery-date");
          tgtDeliverymessagee.style.display = "none";
          //console.log("dfdfdfdfdf")
        return
       
      }

      const data = await response.json();
      const result = CryptoUtil.decryptResponse(data);
      // console.log("resultresult" , result)
      return result;
    } catch (error) {
      console.error("Error:", error);
    }
  }
  let tgtDeliverymessage = document.getElementById("delivery-date");
  if (tgtDeliverymessage != null) {
    var deliverypincode = localStorage.getItem("pincodevalue");
    if (deliverypincode != null) {
      getTAT(deliverypincode).then((result) => {
        // console.log("resultresult" , result)
        if(result==undefined)
        {
              tgtDeliverymessage.style.display = "none";
              tgtDeliverymessage.textContent = `Delivery in ${result?.message}`;
        }
        else{
            tgtDeliverymessage.style.display = "block";
            tgtDeliverymessage.textContent = `Delivery in ${result?.message}`;
        }
        // var pdp_subscribe = document.querySelector(
        //   ".product_btn_card_products"
        // );

        // if (!pdp_subscribe.hasAttribute("disabled")) {
        //   tgtDeliverymessage.style.display = "block";
        //   tgtDeliverymessage.textContent = `Delivery in ${result?.message}`;
        // }
      });
    }
  }
  function getCity(pincode_1) {
const myHeaders = new Headers();
                  myHeaders.append("Content-Type", "application/json");
                  const pincode = {
                    pincode:pincode_1
                  }                  
                  const Key = window.generateRandomString(32);
                  const payload = window.Encrypt(pincode, Key);
                  const sealValue = window.md5(`${payload}${Key}`);
                  myHeaders.append("sealvalue", sealValue);
                  myHeaders.append("key", Key);
                  fetch(`${window.Base_Url.Base_Url}/google-map/geocode?data=${encodeURIComponent(payload)}`, {
                    method: 'GET',
                    headers: myHeaders
                  })
                    .then(response => response.text()) // Assuming response is plain text
                    .then(result => {
                      const plainData = result.split("|")[0];
                      const EncKey = result.split("|")[1].split("%%")[0];
                      const data = window.Decrypt(plainData, EncKey);                             
                      if (data.results && data.results.length > 0) {
                        const addressComponents = data.results[0].address_components;                 
                        const cityComponent = addressComponents.find(component => component.types.includes("locality"));
                        const newcity = cityComponent ? cityComponent.long_name : "";                
                        const stateComponent = addressComponents.find(component => component.types.includes("administrative_area_level_1"));
                        const newstate = stateComponent ? stateComponent.long_name : "";                  
                       document.querySelector(".productPincode").style.display = "flex";
                      document.querySelector(".pincodeValue").textContent = pincode_1;
                      
                      document.getElementById("pincodeCIty").textContent = `${newcity},`;
                      localStorage.setItem("PincodeCity", newcity);
                      location.reload();
                      }
                    })
                    .catch(error => {
                      console.error("Fetch error:", error);
                    });
    //    $.getJSON(`https://api.postalpincode.in/pincode/${pincode_1}`, function(data) {
    //     var data_pincodes = data[0].PostOffice[0].Pincode;
    //     var data_pincodes_length = data_pincodes.length;
    //     if(data[0].PostOffice[0].Block == 'NA'){var city_new = data[0].PostOffice[0].District;}
    //                                       else{var city_new = data[0].PostOffice[0].Block;}

    //     var state_new = data[0].PostOffice[0].State;
    //     var country_new = data[0].PostOffice[0].Country;
    //     var pin_val = $('.pincode-1').val();
    //     $('.deleverypin').text("Deliver to: " +city_new+" "+"("+pin_val+")");
    // $('.changepin').text("Change");
    // $('.pincode_cstm').css('display','none');
    //  localStorage.setItem('PincodeCity', city_new);
    //   });
  }
  var pincodevalue = localStorage.getItem("pincodevalue");
  
  if (!pincodevalue) {
    
    document.getElementById("pincodePopup").style.display = "block";
    document.getElementById("closePopup").style.display = "none";
    document.querySelector(".pincodeOverlay").style.display = "block";
    changepincode = true;
    
    if (changepincode) {
      let checkAvailabilityBtn = document.getElementById("checkAvailability");
      let newCheckAvailabilityBtn = checkAvailabilityBtn.cloneNode(true);
      checkAvailabilityBtn.parentNode.replaceChild(newCheckAvailabilityBtn, checkAvailabilityBtn);

      newCheckAvailabilityBtn.addEventListener('click', async function () {
        
        let tgtpincodevalue = document.getElementById("pincodeInput").value;

        const reqData = {
          pincode: tgtpincodevalue,
        };

        const encrypted = CryptoUtil.encryptRequest("GET", reqData);

        let pincodeResponse = await fetch(`${window.Base_Url.Base_Url}/api/auth/V3/GetStatusV3?iv=${encodeURIComponent(encrypted.iv)}&payload=${encodeURIComponent(encrypted.payload)}`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "seal": encrypted.seal
          }
        })
        let result = await pincodeResponse.json();
        const pincoderesponseData = CryptoUtil.decryptResponse(result);
        let  checkavaliablepincode = pincoderesponseData.status
  
        let newpincodemessage = pincoderesponseData?.message
        if(newpincodemessage=="Pincode not found"){
          availabilityMsg.textContent = "Please Enter Valid pincode";
          availabilityMsg.style.color = "red";
          return
        }
        if (!newpincodemessage && pincoderesponseData.status==false) {
          availabilityMsg.textContent = "Service not avaliable";
          availabilityMsg.style.color = "red";
          return;
        }

        localStorage.setItem("pincodevalue", tgtpincodevalue);
        document.getElementById("pincodePopup").style.display = "none";
        document.querySelector(".pincodeOverlay").style.display = "none";
        document.querySelector(".productPincode").style.display = "flex";
        document.querySelector(".pincodeValue").textContent = tgtpincodevalue;
        const myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        const pincode = {
          pincode:tgtpincodevalue
        }                  
        const Key = window.generateRandomString(32);
        const payload = window.Encrypt(pincode, Key);
        const sealValue = window.md5(`${payload}${Key}`);
        myHeaders.append("sealvalue", sealValue);
        myHeaders.append("key", Key);
        fetch(`${window.Base_Url.Base_Url}/google-map/geocode?data=${encodeURIComponent(payload)}`, {
          method: 'GET',
          headers: myHeaders
        })
        .then(response => response.text())
        .then(result => {
          const plainData = result.split("|")[0];
          const EncKey = result.split("|")[1].split("%%")[0];
          const data = window.Decrypt(plainData, EncKey);                             
          if (data.results && data.results.length > 0) {
            const addressComponents = data.results[0].address_components;                 
            const cityComponent = addressComponents.find(component => component.types.includes("locality"));
            const newcity = cityComponent ? cityComponent.long_name : "";                
            const stateComponent = addressComponents.find(component => component.types.includes("administrative_area_level_1"));
            const newstate = stateComponent ? stateComponent.long_name : "";                  
            localStorage.setItem('PincodeCity', newcity);
            document.getElementById("pincodeCIty").textContent=`${newcity}`
          }
        })
        .catch(error => {
          console.error("Fetch error:", error);
        });
        fetch('/cart/clear.js')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok ' + response.statusText);
          }
          return response.json();
        })
        .then(data => {
                location.reload();
        })
        .catch(error => {
          console.error('There was a problem with the fetch operation:', error);
        });
        
      });
    }
  }
  
  function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  }

  function showPosition(position) {
    var lat = position.coords.latitude;
    var lng = position.coords.longitude;
    var latlng = new google.maps.LatLng(lat, lng);
    var geocoder = new google.maps.Geocoder();
    geocoder.geocode({ latLng: latlng }, (results, status) => {
      if (status !== google.maps.GeocoderStatus.OK) {
        alert(status);
      }
      if (status == google.maps.GeocoderStatus.OK) {
        var postalpin = "";
        for (var i = 0; i < results.length; ++i) {
          var postal = results[i].types[0].trim();
          if (postal == "postal_code") {
            postalpin = results[i].address_components[0].long_name;
          }
        }
        //         if (!postalpin) {
        //         console.log('not found');
        //         }else
        //         {
        //            console.log(postalpin);
        //         }
        //         var pincode_auto =results[0].address_components[8].long_name;
        var pincode_auto = postalpin;

        var pincodevalue = localStorage.getItem("pincodevalue");
        var autofillinputPincode = localStorage.getItem("autofillpincode");

        if (pincode_auto) {
          localStorage.setItem("autofillpincode", "autofill");
          localStorage.setItem("pincodevalue", pincode_auto);
          // localStorage.setItem('storepincode', pincode_auto);
          var pincodevalue = localStorage.getItem("pincodevalue");
          var PinMsg = localStorage.getItem("PinMsg");
          if (pincodevalue != "") {
            getCity(pincodevalue);
          }
        }
      }
    });
  }
  document
    .getElementById("location-detect-btn")
    .addEventListener("click", function () {
      getLocation();
    });
});
// cart-subscription edit
$("body").on("click", ".edit-subscription", function (event) {
  // Select all subscription containers using jQuery
  var subscriptionEdits = $(".cartsubscriiptionContainer");
  // Toggle display for each subscription container
  subscriptionEdits.each(function () {
    var subscriptionEdit = $(this);
    if (subscriptionEdit.css("display") === "none") {
      subscriptionEdit.css("display", "block");
    } else {
      subscriptionEdit.css("display", "none");
    }
  });
});
var Cartsubscription_priod_data;
var subscription_shipped_every;
var Cart_TotalSubscription = 4;
var main_tgt_Subscription_Period;
$("body").on("change", "#cartuserplan", function (event) {
  let carteveryselected = $(this).attr("carteveryselected");
  var selectedOption = $(this).find("option:selected");
  if (selectedOption.length) {
    let tgt_Subscription_Period = selectedOption.val(); // Get the value attribute
    main_tgt_Subscription_Period = selectedOption.val();
    tgt_Subscription_Period = tgt_Subscription_Period * Cart_TotalSubscription;
    localStorage.setItem("Subscription_Period", tgt_Subscription_Period);
    localStorage.setItem("Shipped Every", carteveryselected);
    Cartsubscription_priod_data = selectedOption.text(); 
    if (main_tgt_Subscription_Period == 1) {
      document.getElementById("cart_once_a_month").style.display = "none";
      // document
      //   .getElementById("cart_subscription_week")
      //   .setAttribute("selected", "");
      // subscription_shipped_every="Weekly"
    } else {
      document.getElementById("cart_once_a_month").style.display = "block";
      // document
      //   .getElementById("cart_subscription_week")
      //   .removeAttribute("selected");
      // subscription_shipped_every="Choose"
    }
  }
  
  /*********added code on 26-01-25*****************/
  $("#cartsubscriptionOnEvery").val("-1");
  subscription_shipped_every = "Choose";
  /*********added code on 26-01-25*****************/
  
});
var CartselectedShippedText = "Weekly";
$("body").on("change", "#cartsubscriptionOnEvery", function (event) {
  var selectedOption = $(this).find("option:selected");
  var selectedText = selectedOption.val(); // Get the value attribute
  var rawText = selectedOption.text(); // Get the text content
  // alert(rawText)
  Cart_TotalSubscription = selectedOption.attr("subscription_data");
 subscription_shipped_every = rawText
  // Check the rawText content and update CartselectedShippedText accordingly
  if (rawText.toLowerCase() === "weekly") {
    CartselectedShippedText = "Weekly";
} else if (rawText.toLowerCase().includes("week")) {
    CartselectedShippedText = "Every " + rawText;
} else if (rawText.toLowerCase().includes("month")) {
    CartselectedShippedText = "Every Month";
} else {
    CartselectedShippedText = "Every " + rawText;
}
  var tgt_local_Total_subscription_count =
    Cart_TotalSubscription * main_tgt_Subscription_Period;
  localStorage.setItem(
    "Subscription_Period",
    tgt_local_Total_subscription_count
  );
  // Store the selected value in localStorage
  localStorage.setItem("Shipped Every", selectedText);
});
$("body").on("click", ".cartsubscriptionbtn", async function (event) {
  event.preventDefault(); // Prevent the default action
  // Ensure that Cartsubscription_priod_data and other necessary variables are defined.
  if (!Cartsubscription_priod_data || Cartsubscription_priod_data=="Choose") {
    alert("Subscription Period must be selected");
    return;
  }
   if (!subscription_shipped_every || subscription_shipped_every=="Choose") {
    alert("Shipped Every must be selected");
    return;
  }
  $(this).text("Processing");
  
  try {
    const cartData = await fetchCart();
    let cart_variant_id = cartData.items[0].variant_id;
    let removeFormData = {
      updates: {
        [cart_variant_id]: 0, // Remove the item by setting its quantity to 0
      },
    };

    let removeResponse = await fetch("/cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(removeFormData),
    });

    if (!removeResponse.ok) {
      throw new Error(
        `Failed to remove item. HTTP status: ${removeResponse.status}`
      );
    }
    let tgt_cart_sub_qty = localStorage.getItem("Subscription_quantity");
    let addFormData = {
      items: [
        {
          id: cart_variant_id,
          quantity: tgt_cart_sub_qty,
          properties: {
            subscribe_product: "product",
            "Subscription frequency": CartselectedShippedText,
          },
        },
      ],
      sections: ["cart-drawer", "header"],
    };

    let addResponse = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(addFormData),
    });

    if (!addResponse.ok) {
      throw new Error(`Failed to add item. HTTP status: ${addResponse.status}`);
    }
subscription_shipped_every=""
    const responseData = await addResponse.json();
    let subscribe_header = responseData.sections["cart-drawer"];
    const newDiv = document.createElement("div");
    newDiv.innerHTML = subscribe_header;
    document
      .getElementById("CartDrawer")
      .parentElement.classList.remove("is-empty");
    document.getElementById("CartDrawer").innerHTML =
      newDiv.querySelector("#CartDrawer").innerHTML;

    let cartbubble = responseData.sections["header"];
    const newdivcartbubble = document.createElement("div");
    newdivcartbubble.innerHTML = cartbubble;
    document.querySelector("#cart-icon-bubble").innerHTML =
      newdivcartbubble.querySelector("#cart-icon-bubble").innerHTML;
    Cartsubscription_priod_data = "";
    // CartselectedShippedText = "Every Week";
  } catch (error) {
    console.error("Error updating cart:", error);
  }
});
async function fetchCart() {
  try {
    const response = await fetch("/cart.js", {
      method: "GET",
    });
    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error: ", error);
  }
}
document.addEventListener("DOMContentLoaded", function () {
  const getCurrent = localStorage.getItem("current");
  const getTabindex = localStorage.getItem("tabIndex");
  const url = window.location.href;
  const path = new URL(url).pathname;
  if (path != "/account") {
    if (getCurrent) {
      localStorage.removeItem("current");
    }
    if (getTabindex) {
      localStorage.removeItem("getTabindex");
    }
  }
  document.getElementById("closePopup").addEventListener("click", function () {
    document.getElementById("pincodePopup").style.display = "none";
    document.querySelector(".pincodeOverlay").style.display = "none";
  });
  var tgt_account_check_pincode = localStorage.getItem("pincodevalue");
if (tgt_account_check_pincode) {

    const reqBody = {
      pincode: tgt_account_check_pincode
    };

    const encrypted = CryptoUtil.encryptRequest("POST", reqBody);
    
    const raw = {
      iv: encrypted.iv,
      payload: encrypted.payload
    }

    fetch(`${window.Base_Url.Base_Url}/api/auth/V3/checkregistrationstatusV3`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'seal': encrypted.seal
        },
        body: JSON.stringify(raw)
    })
    .then(response => response.json())
    .then(result => {
        const data = CryptoUtil.decryptResponse(result);
        // Check if the status is "In-active"
        
console.log("checkregistrationstatus", data);

        if (data.Status === "In-active") {
            // Disable the element by adding pointer-events: none
          var account_multiple_earn_point = document.getElementById("account_multiple_earn_point");
          var main_account_multiple_earn_point = document.getElementById("main_account_multiple_earn_point");
          document.getElementById("submitCoupon")?.setAttribute("disabled", true)
          document.getElementById("openCameraBtn")?.setAttribute("disabled", true)
          document.getElementById("serialNumber")?.setAttribute("disabled", true)
          document.getElementById("couponCode")?.setAttribute("disabled", true)
         
          if (account_multiple_earn_point) {
          account_multiple_earn_point.style.pointerEvents = "none";
          account_multiple_earn_point.style.opacity = "0.5"; 
          main_account_multiple_earn_point.style.cursor = "not-allowed";          
}

        }
    })
    .catch(error => {
        console.error("Error fetching registration status:", error);
    });
}
  async function getCartData() {
  const url = 'https://demo.rajnigandha.com/cart.json';

  try {
    // Making the GET request to fetch cart data
    const response = await fetch(url);

    // Check if the response is successful
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    // Parse the JSON response
    const cartData = await response.json();

    // Log the cart data (or process it as needed)
    if(cartData.items.length==0)
    {
      localStorage.removeItem("redeem_product");
      localStorage.removeItem("normal_product_added");
    }


    // Further processing based on the cart data...
  } catch (error) {
    console.error('Error fetching cart data:', error);
  }
}

// Calling the function to get the cart data
getCartData();
async function getStatus(pincode) {

    const reqData = {
      pincode: pincode,
    };

    const encrypted = CryptoUtil.encryptRequest("GET", reqData);

    const url = `${window.Base_Url.Base_Url}/api/auth/V3/GetStatusV3?iv=${encodeURIComponent(encrypted.iv)}&payload=${encodeURIComponent(encrypted.payload)}`;
    const headers = {
        'Content-Type': 'application/json',
        'seal': encrypted.seal,
    };

    try {
        const response = await fetch(url, { headers });

        // Check if the request was successful
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse and return the JSON response
        const result = await response.json();
        const data = CryptoUtil.decryptResponse(result);
        return data;
    } catch (error) {
        console.error('An error occurred:', error);
        throw error; // Re-throw the error for further handling
    }
}

async function checkProductEnable(productIds, pincodes) {
    const url = `${window.Base_Url.Base_Url}/api/auth/V3/checkProductenableV3`;
    
    // Prepare the payload
    const payload = {
        productIds: productIds.map(id => ({ id })),
        pincodes: pincodes
    };

    const encrypted = CryptoUtil.encryptRequest("POST", payload);

    const headers = {
        'Content-Type': 'application/json',
        'seal': encrypted.seal,
    };

    const raw = {
      iv: encrypted.iv,
      payload: encrypted.payload,
    }


    try {
        // Send the POST request
        const response = await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(raw)
        });

        // Check if the request was successful
        if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
        }

        // Parse and return the JSON response
        const result = await response.json();
        const data = CryptoUtil.decryptResponse(result);
        return data;
    } catch (error) {
        console.error('An error occurred:', error);
        throw error; // Re-throw the error for further handling
    }
}

async function handleCheck(productIds) {
    const pincodes = localStorage.getItem("pincodevalue");
  if(pincodes)
  {
     try {
        // First, check status from the GetStatus API
        const statusResult = await getStatus(pincodes);
        
        // If status is false, disable all elements
        if (statusResult.status === false) {
            disableElements();
        } else {
            // Proceed with checkProductEnable if status is true
            const result = await checkProductEnable(productIds, pincodes);
            if (result.allActive === false) {
                disableElements();
            }
        }
    } catch (error) {
        console.error('Error:', error);
    }
  }

   
}

function disableElements() {
    const mainAccountMultipleEarnPoint = document.getElementById("main_account_multiple_earn_point");
    const accountMultipleEarnPoint = document.getElementById("account_multiple_earn_point");
    const submitCoupon = document.getElementById("submitCoupon");
    const openCameraBtn = document.getElementById("openCameraBtn");
    const serialNumber = document.getElementById("serialNumber");
    const couponCode = document.getElementById("couponCode");

    if (mainAccountMultipleEarnPoint) {
        mainAccountMultipleEarnPoint.style.cursor = "not-allowed";
    }

    if (accountMultipleEarnPoint) {
        accountMultipleEarnPoint.style.opacity = "0.7";
        accountMultipleEarnPoint.style.pointerEvents = "none";
    }

    if (submitCoupon) {
        submitCoupon.setAttribute("disabled", "");
    }

    if (openCameraBtn) {
        openCameraBtn.setAttribute("disabled", "");
    }

    if (serialNumber) {
        serialNumber.setAttribute("readOnly", true);
        serialNumber.style.opacity = "0.7";
    }

    if (couponCode) {
        couponCode.setAttribute("readOnly", true);
        couponCode.style.opacity = "0.7";
    }
}

const productIds = ["gid://shopify/Product/8934260506855"];
handleCheck(productIds);

   let pincodeData = localStorage.getItem("pincodevalue");
  if(pincodeData)
  {
    document.querySelectorAll(".redeem_not_servicable").forEach((item) => {
      
                    let pincodeattr = item.getAttribute('pincode-data');
                    let errorElement = item.closest(".redeem_main_common").querySelector(".redeem_not_serviciable_error");
                    if (pincodeattr) {
                        let pincodeDataarr = pincodeattr.split(",");
                        let checkcardpincode = pincodeDataarr.some((pin) => {
                            return pin == pincodeData;
                        });

                        if (checkcardpincode) {
                            errorElement.style.display = "block";                          
                          item.closest(".redeem_main_common").classList.add("main_redeem_div")
                          item.style.pointerEvents="none"
                        }                    
                    }
                });
  }else{
    var account_multiple_earn_point = document.getElementById("account_multiple_earn_point");
          if (account_multiple_earn_point) {
          // account_multiple_earn_point.style.pointerEvents = "none";
          // account_multiple_earn_point.style.opacity = "0.5"; 
          // main_account_multiple_earn_point.style.cursor = "not-allowed";      
         document.getElementById("submitCoupon")?.setAttribute("disabled", true);
document.getElementById("openCameraBtn")?.setAttribute("disabled", true);
document.getElementById("serialNumber")?.setAttribute("disabled", true);
document.getElementById("couponCode")?.setAttribute("disabled", true);

const serialInput = document.getElementById("serialNumber");
const couponInput = document.getElementById("couponCode");

if (serialInput) serialInput.style.cursor = "not-allowed";
if (couponInput) couponInput.style.cursor = "not-allowed";

}
  }
});

document.addEventListener("DOMContentLoaded", function () {
    const urlParams = new URLSearchParams(window.location.search);
    const value = urlParams.get("value");
    const hash = window.location.hash;
    if (value === "Rewards" && hash === "#RajnigandhaProducts") {
        // Click the Rewards button
        const rewardsButton = document.querySelector("#redeem-dashboard");
        if (rewardsButton) {
            rewardsButton.click();

            // Wait for the Rewards section to load, then click RajnigandhaProducts button
            setTimeout(() => {
                const rajnigandhaButton = document.querySelector('a[data-target="tab-rajni-products"]');
                if (rajnigandhaButton) {
                    rajnigandhaButton.click();
                }
            }, 500); // Adjust the timeout based on load time
        }
    }else if(value === "Rewards" && hash === "#FoodProducts"){
       // Click the Rewards button
        const rewardsButton = document.querySelector("#redeem-dashboard");
        if (rewardsButton) {
            rewardsButton.click();

            // Wait for the Rewards section to load, then click RajnigandhaProducts button
            setTimeout(() => {
                const rajnigandhaButton = document.querySelector('a[data-target="tab-food-products"]');
                if (rajnigandhaButton) {
                    rajnigandhaButton.click();
                }
            }, 500); // Adjust the timeout based on load time
        }
    }else if(value === "Rewards" && hash === "#Evouchers"){
       // Click the Rewards button
        const rewardsButton = document.querySelector("#redeem-dashboard");
        if (rewardsButton) {
            rewardsButton.click();

            // Wait for the Rewards section to load, then click RajnigandhaProducts button
            setTimeout(() => {
                const rajnigandhaButton = document.querySelector('a[data-target="tab-e-vouchers"]');
                if (rajnigandhaButton) {
                    rajnigandhaButton.click();
                }
            }, 500); // Adjust the timeout based on load time
        }
    }else if(value === "Rewards" && hash === "#GiftVoucher"){
       // Click the Rewards button
        const rewardsButton = document.querySelector("#redeem-dashboard");
        if (rewardsButton) {
            rewardsButton.click();

            // Wait for the Rewards section to load, then click RajnigandhaProducts button
            setTimeout(() => {
                const rajnigandhaButton = document.querySelector('a[data-target="tab-gift-voucher"]');
                if (rajnigandhaButton) {
                    rajnigandhaButton.click();
                }
            }, 500); // Adjust the timeout based on load time
        }
    }else if(value === "Rewards" && hash === "#Merchandise"){
       // Click the Rewards button
        const rewardsButton = document.querySelector("#redeem-dashboard");
        if (rewardsButton) {
            rewardsButton.click();

            // Wait for the Rewards section to load, then click RajnigandhaProducts button
            setTimeout(() => {
                const rajnigandhaButton = document.querySelector('a[data-target="tab-merchandise"]');
                if (rajnigandhaButton) {
                    rajnigandhaButton.click();
                }
            }, 500); // Adjust the timeout based on load time
        }
    }
    
});